<div
  class="flex flex--wrap font-body-1 white-text rounded-border destinations-campaign-ribbon"
  [class.nordic-blue-900-bg]="!theme"
  [class.black-bg]="theme === CmsTaxonomyGeneral.BLACK_FRIDAY"
  [class.heather-700-bg]="theme === CmsTaxonomyGeneral.HEATHER_BG"
  data-testid="destinations-campaign-ribbon"
>
  <div class="flex flex--middle">
    <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CLOCK"></fcom-icon>
    <div class="ms-xsmall-l">
      <p>
        {{ bookByText }}
      </p>
    </div>
  </div>
  <div class="flex flex--middle">
    <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.TIMETABLE"></fcom-icon>
    <div class="ms-xsmall-l">
      <p>
        {{ travelPeriodText }}
      </p>
    </div>
  </div>
  <div class="flex flex--middle">
    <a
      class="white-text"
      [innerHTML]="termsAndConditionText"
      [href]="termsAndConditionLink"
      (click)="onLinkClick($event)"
      data-testid="destinations-terms-condition-link"
    ></a>
  </div>
</div>
